import {
  MarketViewQueryCalendarStripAverageResponse,
  MarketViewQueryDailyPricesResponse,
  MarketViewQueryForwardCurveResponse,
  MarketViewQueryPriceResponse,
  MarketViewQueryRollingMonthAheadResponse,
  MarketViewQuerySettlementsResponse,
  MarketViewQueryStripAverageResponse,
} from '../Generated/Mark-It-View-Api';

enum PriceQueryType {
  Price = 'Price',
  StripAverage = 'Strip Average',
  CalendarStripAverage = 'Calendar Strip Average',
  RollingMonthAhead = 'Rolling Month Ahead',
  Rolling12MonthStrip = 'Rolling 12 Month Strip',
  ForwardCurve = 'Forward Curve',
  Settlement = "Settlement",
  // A daily assessment has no contract month, so its response is shaped differently and
  // the display builds its series from the close price alone. The user never picks this:
  // a daily priced product runs as Price, and the form tags the result with it so the
  // display knows which shape came back.
  DailyPrice = 'Daily Price',
}

type PriceQueryResult =
  | MarketViewQueryPriceResponse
  | MarketViewQueryStripAverageResponse
  | MarketViewQueryCalendarStripAverageResponse
  | MarketViewQueryRollingMonthAheadResponse
  | MarketViewQueryForwardCurveResponse
  | MarketViewQuerySettlementsResponse
  | MarketViewQueryDailyPricesResponse;

/** Selectable in the Price Query Type dropdown. DailyPrice is internal only. */
const PriceQueryTypeOptions = Object.keys(PriceQueryType)
  .map((key) => PriceQueryType[key as keyof typeof PriceQueryType])
  .filter((type) => type !== PriceQueryType.DailyPrice);

/** The only query a daily priced product can run - there is one price per day. */
const DailyPriceQueryTypeOptions = [PriceQueryType.Price];

export type { PriceQueryResult };
export { PriceQueryType, PriceQueryTypeOptions, DailyPriceQueryTypeOptions };
